import CurrencyCell from 'components/CustomGridCell/CurrencyCell';
import { AdjustmentType } from 'enums';
import { AdjustmentCategoryGridProps } from 'types';

const props: AdjustmentCategoryGridProps = {
    category: AdjustmentType.Quantity,
    adjustmentTypes: [AdjustmentType.Quantity],
    title: 'Quantity Adjustment',
    dataItemKey: 'rowNumber',
    selectMode: 'single',
    gridColumns: [
        {
            field: 'manufacturerItemNumber',
            title: 'Manufacturer Item ID',
            filterTitle: 'text'
        },
        {
            field: 'inventoryItemId',
            title: 'Dot Item Number'
        },
        {
            field: 'voucherQuantity',
            title: 'Original Quantity',
            filterTitle: 'numeric'
        },
        {
            field: 'quantity',
            title: 'Adjusted By:',
            filterTitle: 'numeric'
        },
        {
            field: 'adjustmentUnitPrice',
            title: 'Unit Price',
            cell: CurrencyCell,
            filterTitle: 'numeric'
        },
        {
            field: 'adjustmentAmount',
            title: 'Total Adjustments',
            cell: CurrencyCell,
            filterTitle: 'numeric'
        }
    ]
}
export default props;